import type { TFunction } from "i18next";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { EVENT_MANAGEMENT_BROWSER_ROUTES } from "./browser.routes";
import { PERMISSIONS } from "@constants/user.roles";
import {
	EVENT_CREATION_ACCESS_PERMISSIONS,
	EVENT_MANAGEMENT_ACCESS_PERMISSIONS,
	EVENTS_REQUEST_ACCESS_PERMISSIONS,
} from "./permissions";
import {
	EVENT_CREATION_MENU_KEY,
	EVENT_MANAGEMENT_MENU_KEY,
	EVENTS_CLONE_MENU_KEY,
	EVENTS_REQUEST_MENU_KEY,
} from "./menu.keys";

export interface EventManagementMenuOptions {
	/** Events Request (PSDA / system admin / endorsement workflow permissions). */
	includeEventsRequest?: boolean;
}

/** Sidebar menu block for Event Management. */
export function getEventManagementMenuItem(t: TFunction, options: EventManagementMenuOptions = {}) {
	const { includeEventsRequest = false } = options;

	const children = [
		{
			key: EVENT_CREATION_MENU_KEY,
			label: t("layout.sidebar.menuName.subMenu.eventCreation"),
			icon: <AddCircleOutlineOutlinedIcon fontSize="small" />,
			route: EVENT_MANAGEMENT_BROWSER_ROUTES.EVENT_CREATION,
			requiredAnyOfPermissions: [...EVENT_CREATION_ACCESS_PERMISSIONS],
		},
		...(includeEventsRequest
			? [
					{
						key: EVENTS_REQUEST_MENU_KEY,
						label: t("layout.sidebar.menuName.subMenu.eventsRequest"),
						icon: <PlaylistAddCheckOutlinedIcon fontSize="small" />,
						route: EVENT_MANAGEMENT_BROWSER_ROUTES.EVENTS_REQUEST,
						requiredAnyOfPermissions: [...EVENTS_REQUEST_ACCESS_PERMISSIONS],
					},
				]
			: []),
		{
			key: EVENTS_CLONE_MENU_KEY,
			label: t("layout.sidebar.menuName.subMenu.eventsClone"),
			icon: <ContentCopyOutlinedIcon fontSize="small" />,
			route: EVENT_MANAGEMENT_BROWSER_ROUTES.EVENTS_CLONE,
			requiredPermission: PERMISSIONS.CLONE_CALENDAR_EVENT,
			requireExplicitPermission: true,
		},
	];

	return {
		key: EVENT_MANAGEMENT_MENU_KEY,
		label: t("layout.sidebar.menuName.eventManagement"),
		icon: <EventAvailableOutlinedIcon fontSize="medium" />,
		route: EVENT_MANAGEMENT_BROWSER_ROUTES.EVENT_CREATION,
		requiredAnyOfPermissions: [...EVENT_MANAGEMENT_ACCESS_PERMISSIONS],
		children,
	};
}
